import React from "react"
import {Button} from "@mui/material"
import {useNavigate} from "react-router-dom"

function Home(){
    const navigate = useNavigate()

    const search =()=>{
        navigate("/dictionary")

    }
    return(
        <div style={{backgroundImage:"https://builtin.com/sites/www.builtin.com/files/styles/og/public/2023-01/convert-list-to-dictionary-python.jpg"}}>
        <div style={{position:"fixed",left:"45%",top:"45%"}}>
        <h2>LET'S <br/> START  <br/> TO EXPLORE </h2>
<Button variant="contained" sx={{bgcolor:"black", color:"wheat"}} onClick={search}>Start</Button>
        </div></div>
    )
}
export default Home